export const people_data = {};